export const PostBody: React.FC<{ content: string }> = ({ content }) => {
  return (
    <div className='post-body mx-auto'>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};
